import {makeAutoObservable} from "mobx";

export class ChatHistoryStorage {
    CHAT_HISTORY = 'marketplace-chat-history';
    CHAT_SESSION_ID = 'marketplace-chat-session-id';

    constructor(storage) {
        this._storage = storage;
        this._messages = this._storage.get(this.CHAT_HISTORY) || null;
        makeAutoObservable(this);
    }

    addMessages(messages) {
        this._messages = JSON.stringify(messages || []);
        this._storage.add(this.CHAT_HISTORY, this._messages);
    }

    getMessages() {
        this._messages = this._storage.get(this.CHAT_HISTORY);
        if (!this._messages) {
            return [];
        }
        try {
            return JSON.parse(this._messages) || [];
        } catch (error) {
            return [];
        }
    }

    getOrCreateSessionId() {
        const existing = this._storage.get(this.CHAT_SESSION_ID);
        if (existing) {
            return existing;
        }
        const newId = crypto.randomUUID();
        this._storage.add(this.CHAT_SESSION_ID, newId);
        return newId;
    }

    clear() {
        this._messages = undefined;
        this._storage.remove(this.CHAT_HISTORY);
        this._storage.remove(this.CHAT_SESSION_ID);
    }
}
